import { apiInstance, handleApiError } from "./InstanceApi";

export const getChatHistoryService = async ({
  message,
  page,
  limit,
  target,
  start_date,
  end_date,
}) => {
  const safeMessage = message == null ? "" : message;
  const safeTarget = target == null ? "" : target;
  const safeStartDate = start_date == null ? "" : start_date;
  const safeEndDate = end_date == null ? "" : end_date;
  try {
    const response = await apiInstance.get(`client-chat-search`, {
      params: {
        page: page,
        limit: limit,
        message: safeMessage,
        target: safeTarget,
        start_date: safeStartDate,
        end_date: safeEndDate,
      },
    });
    return response?.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getTargetCountService = async (target) => {
  try {
    const response = await apiInstance.get(`get-count-logs`, {
      params: {
        target: target,
      },
    });
    return response?.data;
  } catch (error) {
    return handleApiError(error);
  }
};
